var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.5H0.5V7.5V11.0429L3.95711 14.5H7.5H14.5V0.5Z",
    stroke: "#FAE232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxHover);
export default __webpack_public_path__ + "static/media/checkbox_hover.9f46ce579306dd3e510b4fd239a1b3e2.svg";
export { ForwardRef as ReactComponent };